import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-session-required',
  imports: [RouterLink],
  templateUrl: './session-required.content.page.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionRequiredPageContent {
  @HostBinding('class')
  protected readonly hostClass = 'auth-page';
}
